// extracted by mini-css-extract-plugin
export var address = "TheNeighborhood-module--address--dc379";
export var arrow = "TheNeighborhood-module--arrow--9c364";
export var backButton = "TheNeighborhood-module--backButton--ffc24";
export var cardCarousel = "TheNeighborhood-module--cardCarousel--99710";
export var cardWrapper = "TheNeighborhood-module--cardWrapper--658cd";
export var carousel = "TheNeighborhood-module--carousel--db3a4";
export var container = "TheNeighborhood-module--container--0c88d";
export var decor = "TheNeighborhood-module--decor--5d0cc";
export var description = "TheNeighborhood-module--description--4047f";
export var directions = "TheNeighborhood-module--directions--31f42";
export var divider = "TheNeighborhood-module--divider--b30aa";
export var image = "TheNeighborhood-module--image--847ef";
export var info = "TheNeighborhood-module--info--2a015";
export var infoBlock = "TheNeighborhood-module--infoBlock--a3241";
export var infoCarousel = "TheNeighborhood-module--infoCarousel--de89b";
export var infoWrapper = "TheNeighborhood-module--infoWrapper--b6b1e";
export var name = "TheNeighborhood-module--name--2c95d";
export var nextButton = "TheNeighborhood-module--nextButton--da3bb";
export var relativeWrapper = "TheNeighborhood-module--relativeWrapper--cd4fe";